import {ChangeDetectorRef, Component, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractLocalisationInput} from "../abstract-localisation-input";
import {FUIResponsiveService} from "../../../../page/responsive.service";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIEditLocalisationInputComponent),
            multi: true
        }
    ],
    selector: "fui-edit-localisation-input",
    templateUrl: "./edit-localisation-input.component.html",
    standalone: false
})
export class FUIEditLocalisationInputComponent extends FUIAbstractLocalisationInput {
    constructor(responsiveService: FUIResponsiveService,
                changeDetectorRef: ChangeDetectorRef) {
        super(responsiveService, changeDetectorRef);
    }

    override ngOnInit(): void {
    }
}
